export default "__VITE_ASSET__ngQ89VZI__"